module.exports = __webpack_public_path__ + "static/media/img_simulation_assessment_info_arnose.1ef38079.jpg";